import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const EditorSectionIcons = {
    effects: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "wand"
            }),
            /*#__PURE__*/ _jsxs("g", {
                strokeWidth: "1",
                fill: "#ffffff",
                stroke: "#ffffff",
                children: [
                    /*#__PURE__*/ _jsx("polygon", {
                        points: "0.5 13.5 2.5 15.5 11.487 6.487 9.513 4.487 0.5 13.5",
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("line", {
                        x1: "7.513",
                        y1: "6.487",
                        x2: "9.513",
                        y2: "8.487",
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("line", {
                        x1: "15.5",
                        y1: "0.5",
                        x2: "12.5",
                        y2: "3.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    /*#__PURE__*/ _jsx("line", {
                        x1: "12.5",
                        y1: "0.5",
                        x2: "15.5",
                        y2: "3.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    /*#__PURE__*/ _jsx("line", {
                        x1: "15.5",
                        y1: "10.5",
                        x2: "12.5",
                        y2: "13.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    /*#__PURE__*/ _jsx("line", {
                        x1: "12.5",
                        y1: "10.5",
                        x2: "15.5",
                        y2: "13.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    /*#__PURE__*/ _jsx("line", {
                        x1: "6.5",
                        y1: "0.5",
                        x2: "3.5",
                        y2: "3.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    /*#__PURE__*/ _jsx("line", {
                        x1: "3.5",
                        y1: "0.5",
                        x2: "6.5",
                        y2: "3.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    })
                ]
            })
        ]
    }),
    layer: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "stack"
            }),
            /*#__PURE__*/ _jsxs("g", {
                strokeWidth: "1",
                fill: "#ffffff",
                stroke: "#ffffff",
                children: [
                    /*#__PURE__*/ _jsx("polygon", {
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "10",
                        points: "8,1.5 15.5,6 8,10.5 0.5,6 "
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("polyline", {
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeMiterlimit: "10",
                        points: "14,9.1 15.5,10 8,14.5 0.5,10 2,9.1 ",
                        "data-color": "color-2"
                    }),
                    " "
                ]
            })
        ]
    }),
    display: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "artboard"
            }),
            /*#__PURE__*/ _jsxs("g", {
                strokeWidth: "1",
                fill: "#ffffff",
                stroke: "#ffffff",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        x: "3.5",
                        y: "3.5",
                        width: "9",
                        height: "9",
                        rx: "1",
                        ry: "1",
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "3.5",
                        y1: "0.5",
                        x2: "3.5",
                        y2: "1.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "12.5",
                        y1: "0.5",
                        x2: "12.5",
                        y2: "1.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "3.5",
                        y1: "14.5",
                        x2: "3.5",
                        y2: "15.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "12.5",
                        y1: "14.5",
                        x2: "12.5",
                        y2: "15.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "0.5",
                        y1: "3.5",
                        x2: "1.5",
                        y2: "3.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "0.5",
                        y1: "12.5",
                        x2: "1.5",
                        y2: "12.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "14.5",
                        y1: "3.5",
                        x2: "15.5",
                        y2: "3.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "14.5",
                        y1: "12.5",
                        x2: "15.5",
                        y2: "12.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    })
                ]
            })
        ]
    }),
    text: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "caps-small"
            }),
            /*#__PURE__*/ _jsxs("g", {
                strokeWidth: "1",
                fill: "#ffffff",
                stroke: "#ffffff",
                children: [
                    /*#__PURE__*/ _jsx("polyline", {
                        points: "0.5 3.5 0.5 1.5 12.5 1.5 12.5 3.5",
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "6.5",
                        y1: "1.5",
                        x2: "6.5",
                        y2: "14.5",
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "4.5",
                        y1: "14.5",
                        x2: "8.5",
                        y2: "14.5",
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("polyline", {
                        points: "9.5 8.5 9.5 7.5 15.5 7.5 15.5 8.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "12.5",
                        y1: "7.5",
                        x2: "12.5",
                        y2: "14.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "14",
                        y1: "14.5",
                        x2: "11",
                        y2: "14.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    })
                ]
            })
        ]
    }),
    size: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "full-screen"
            }),
            /*#__PURE__*/ _jsxs("g", {
                strokeWidth: "1",
                fill: "#ffffff",
                stroke: "#ffffff",
                children: [
                    " ",
                    /*#__PURE__*/ _jsx("rect", {
                        x: "0.5",
                        y: "1.5",
                        width: "15",
                        height: "13",
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("polyline", {
                        points: "13 7.5 13 4 9.5 4",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("polyline", {
                        points: "6.5 12 3 12 3 8.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " "
                ]
            })
        ]
    }),
    margin: /*#__PURE__*/ _jsxs("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12.4 4H4.6C4.26863 4 4 4.26863 4 4.6V12.4C4 12.7314 4.26863 13 4.6 13H12.4C12.7314 13 13 12.7314 13 12.4V4.6C13 4.26863 12.7314 4 12.4 4Z",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7 1H10",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16 7V10",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M10 16H7",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1 10V7",
                stroke: "white",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }),
    corners: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "border-radius"
            }),
            /*#__PURE__*/ _jsxs("g", {
                strokeWidth: "1",
                fill: "#ffffff",
                stroke: "#ffffff",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M.5,4.5v-2a2,2,0,0,1,2-2h2",
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.5,4.5v-2a2,2,0,0,0-2-2h-2",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("path", {
                        d: "M.5,11.5v2a2,2,0,0,0,2,2h2",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("path", {
                        d: "M15.5,11.5v2a2,2,0,0,1-2,2h-2",
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        ]
    }),
    padding: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "border"
            }),
            /*#__PURE__*/ _jsxs("g", {
                strokeWidth: "1",
                fill: "#ffffff",
                stroke: "#ffffff",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        x: "0.5",
                        y: "0.5",
                        width: "15",
                        height: "15",
                        rx: "1",
                        ry: "1",
                        fill: "none",
                        stroke: "#ffffff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "6.5",
                        y1: "3.5",
                        x2: "9.5",
                        y2: "3.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "12.5",
                        y1: "6.5",
                        x2: "12.5",
                        y2: "9.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "9.5",
                        y1: "12.5",
                        x2: "6.5",
                        y2: "12.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "3.5",
                        y1: "9.5",
                        x2: "3.5",
                        y2: "6.5",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    })
                ]
            })
        ]
    }),
    position: /*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "position"
            }),
            /*#__PURE__*/ _jsxs("g", {
                strokeWidth: "1",
                fill: "currentColor",
                stroke: "currentColor",
                children: [
                    /*#__PURE__*/ _jsx("circle", {
                        cx: "8.5",
                        cy: "8.5",
                        r: "2",
                        fill: "none",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        "data-color": "color-2"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "8.5",
                        y1: "1.5",
                        x2: "8.5",
                        y2: "3.5",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "1.5",
                        y1: "8.5",
                        x2: "3.5",
                        y2: "8.5",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "13.5",
                        y1: "8.5",
                        x2: "15.5",
                        y2: "8.5",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("line", {
                        x1: "8.5",
                        y1: "13.5",
                        x2: "8.5",
                        y2: "15.5",
                        fill: "none",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            })
        ]
    })
};
